/** Katalog intencji kotka-strażnika — id → ikona (+ opcjonalny dźwięk). */

export const COMPANION_INTENTS = {
  WHERE_TO_GO: { icon: 'ico_hint_map', labelPl: 'Nie wiem gdzie iść' },
  HOW_TO_WIN: { icon: 'ico_hint_star', labelPl: 'Nie umiem wygrać' },
  HOW_TO_EARN: { icon: 'ico_hint_coin', labelPl: 'Jak zarobić pieniążki?' },
  WHERE_BUY: { icon: 'ico_hint_shop', labelPl: 'Gdzie kupię ubranka?' },
  HOW_TO_BUILD: { icon: 'ico_hint_build', labelPl: 'Jak zbudować dom?' },
  LOST: { icon: 'ico_hint_lost', labelPl: 'Zgubiłam się' },
  GREETING: { icon: 'ico_hint_wave', labelPl: 'Cześć' },
  FALLBACK: { icon: 'ico_hint_heart', labelPl: 'Hmm…' },
  REST: { icon: 'ico_hint_sleep', labelPl: 'Odpoczynek' },
  MINIGAME_NO_PROGRESS: { icon: 'ico_hint_tap', labelPl: 'Mini-gra' },
  TAP_NOTHING: { icon: 'ico_hint_arrow', labelPl: 'Zobacz tutaj!' },
  SERVER_DENIED: { icon: 'ico_hint_coin', labelPl: 'Za mało zł' },
  LOCKED_PLACE: { icon: 'ico_hint_lock', labelPl: 'Zamknięte' },
  IDLE_LONG: { icon: 'ico_hint_wave', labelPl: 'Zrób coś' },
  /** 90 s bezczynności w żywym świecie (PLAN-V2 §4.3). */
  WORLD_IDLE: { icon: 'ico_hint_map', labelPl: 'Świat czeka' },
  /** Pierwsza interakcja danego typu w sesji (PLAN-V2 §3.3). */
  FIRST_INTERACTION_TAP: { icon: 'ico_hint_tap', labelPl: 'Stuknięcie' },
  FIRST_INTERACTION_DRAG: { icon: 'ico_hint_arrow', labelPl: 'Przeciąganie' },
  FIRST_INTERACTION_PICKUP: { icon: 'ico_hint_star', labelPl: 'Podniesienie' },
  FIRST_INTERACTION_GIVE: { icon: 'ico_hint_heart', labelPl: 'Podanie' },
  FIRST_INTERACTION_CONSUME: { icon: 'ico_hint_coin', labelPl: 'Smakołyk' },
  FIRST_INTERACTION_TOGGLE: { icon: 'ico_hint_tap', labelPl: 'Przełącznik' },
  FIRST_INTERACTION_BOUNCE: { icon: 'ico_hint_star', labelPl: 'Odbicie' },
} as const;

export type CompanionIntentId = keyof typeof COMPANION_INTENTS;

export const COMPANION_INTENT_IDS = Object.keys(
  COMPANION_INTENTS,
) as CompanionIntentId[];
